import { render, staticRenderFns } from "./juegoDespedida.vue?vue&type=template&id=73882da5&scoped=true&"
import script from "./juegoDespedida.vue?vue&type=script&lang=js&"
export * from "./juegoDespedida.vue?vue&type=script&lang=js&"
import style0 from "./juegoDespedida.vue?vue&type=style&index=0&id=73882da5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73882da5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
